let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cXodu")).then(() => parcelRequire('aH2D0'));